export const LabelCornerLocation = Object.freeze({
    No: 'no',
    Left: 'left',
    Right: 'right',
});
